module.exports = __webpack_public_path__ + "static/img/9.92b1d2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/9.png
// module id = tXyi
// module chunks = 1